// Pull index.css into the ENTRY chunk so MiniCssExtractPlugin emits a
// main.<hash>.css file that HtmlWebpackPlugin auto-injects as a synchronous
// <link> in index.html. Without this, CSS only lives in an async route-chunk
// (because bootstrap.tsx is dynamically imported below), the runtime injects
// the <link> after React's first paint, and the page renders unstyled.
import './index.css';

// Async boundary required for Webpack 5 Module Federation with eager shared modules
// (react, react-dom). The dynamic import lets federation negotiate singletons before
// bootstrap.tsx executes, preventing "Shared module is not available for eager
// consumption" runtime errors.
void import('./bootstrap');
